export interface IExplodedPromise<T> {
  promise: Promise<T>
  resolve(value: T): void
  reject(reason: any): void
}

export function explodePromise<T>(): IExplodedPromise<T> {
  let resolve: any
  let reject: any

  const promise = new Promise<T>((res, rej) => {
    resolve = res
    reject = rej
  })

  return { resolve, reject, promise }
}
